import { createConfigLoader } from "@/config";
import { CacheTag } from "@/enums/cacheTags";

/**
 * Interface for cache lifetime configuration
 */
export interface ICacheLifetimeConfig {
  cacheTTL: Record<CacheTag, number>;
}

/**
 * Time to live (TTL) for each cache tag in seconds.
 * All values are centralized in one place for easy modification
 * cache duration without modifying services.
 */

export const CACHE_TTL_1_HOUR = 3600;

// Default cache lifetime configuration
const defaultCacheLifetimeConfig: ICacheLifetimeConfig = {
  cacheTTL: {
    // Search
    [CacheTag.SEARCH_RECOMMENDED_CITY]: CACHE_TTL_1_HOUR,
    [CacheTag.SEARCH_REGION]: CACHE_TTL_1_HOUR,
    [CacheTag.SEARCH_PROPERTY_TYPE]: CACHE_TTL_1_HOUR,
    [CacheTag.SEARCH_CHECKBOXES]: CACHE_TTL_1_HOUR,
    [CacheTag.SEARCH_PROPERTY_OPTIONS]: CACHE_TTL_1_HOUR,

    // Collections / lists
    [CacheTag.PROPERTY_COLLECTION]: CACHE_TTL_1_HOUR,

    // SEO - Optimized cache durations for better performance
    [CacheTag.SEO_METADATA]: CACHE_TTL_1_HOUR, // Keep 1 hour for metadata freshness
    [CacheTag.SEO_TEMPLATE]: CACHE_TTL_1_HOUR * 4, // 4 hours - templates change rarely
    [CacheTag.SEO_TEMPLATES_BATCH]: CACHE_TTL_1_HOUR * 4, // 4 hours - batch operations
    [CacheTag.SEO_VARIABLES]: CACHE_TTL_1_HOUR * 2, // 2 hours - variables more stable
  },
};

// Load configuration with country-specific overrides
const cacheLifetimeConfigData = createConfigLoader(
  defaultCacheLifetimeConfig,
  "cacheLifetime",
);

// Export for backward compatibility
export const CACHE_TTL = cacheLifetimeConfigData.cacheTTL;
